module.exports = __webpack_public_path__ + "img/esoseska_homepage_3.96bfc33a.png";